import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-one-column-title',
  templateUrl: './one-column-title.component.html',
  styleUrls: ['./one-column-title.component.scss']
})
export class OneColumnTitleComponent implements OnInit {

    @Input() title: any = '';
    @Input() width: any = 'FULL';

    constructor() { }

    ngOnInit(): void {
    }

}
